import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ui-card-cross',
  templateUrl: './card-cross.component.html',
  styleUrls: ['./card-cross.component.scss'],
  standalone: false
})
export class CardCrossComponent {
  @Input() pid: string;
  @Input() cardName: string;
  @Output() delete = new EventEmitter<string>();

  public imagePrefix: any;

  constructor(private mktEnvironmentService: MktEnvironmentService) {
    this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
  }

  handleClick(pId: string) {
    this.delete.emit(pId);
  }

  getAriaLabel() {
    return `${this.cardName} remove`;
  }
}
